import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ErrorWithIcon } from "../inputs/ValidationMessage";
export const PhoneInputMasking = ({ control, name, label, error, rules, disabled = false, }) => {
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: ({ field: { onChange, value } }) => (_jsxs(Box, { className: "tel-input-container", sx: {
                width: "100%",
                "& .react-tel-input": { width: "100%" },
                "& .react-tel-input *": { fontFamily: "SuisseIntl" },
                "& .react-tel-input .form-control": {
                    width: "100% !important",
                    transition: "border 0.3s",
                    borderColor: "transparent",
                    "&:focus": {
                        borderColor: "#0F92FD !important",
                    },
                },
                "& .react-tel-input .country-list": {
                    maxHeight: "200px",
                    overflowY: "auto",
                    zIndex: 1000,
                },
                "& .react-tel-input .country-list .search-box": {
                    width: "calc(100% - 34px)",
                    padding: "8px 12px",
                    borderRadius: "8px",
                },
                "& .react-tel-input .selected-flag": {
                    borderRadius: "8px 0 0 8px",
                    border: "none !important",
                    backgroundColor: "transparent !important",
                },
                "& .react-tel-input .flag-dropdown": {
                    borderRadius: "8px 0 0 8px",
                    border: "none !important",
                },
                backgroundColor: (theme) => theme.palette.background.paper,
                borderRadius: 1,
            }, children: [_jsxs(Box, { position: "relative", borderRadius: 8, children: [_jsx(Typography, { sx: {
                                position: "absolute",
                                top: 6,
                                left: 41,
                            }, fontSize: "12px", fontFamily: "SuisseIntl", color: disabled ? "#919EAB" : "#6C757D", children: label }), _jsx(PhoneInput, { country: "nl", value: value, onChange: (phone) => onChange(phone), inputStyle: {
                                width: "100%",
                                height: "56px",
                                fontSize: "0.875rem",
                                fontFamily: "SuisseIntl",
                                borderColor: error ? "#d32f2f" : "#00244D33",
                                backgroundColor: "transparent",
                                paddingLeft: "40px",
                                borderRadius: "8px",
                                paddingTop: "25px",
                                paddingBottom: "6px",
                                color: disabled ? "#919EAB" : "#00244D",
                                border: disabled
                                    ? "1px solid rgb(223, 227, 232)"
                                    : "1px solid #CACACA",
                            }, buttonStyle: {
                                backgroundColor: "transparent",
                                borderColor: error ? "#d32f2f" : "#00244D33 ",
                                borderRight: "none",
                            }, dropdownStyle: {
                                width: "max-content",
                                maxHeight: "300px",
                                overflowY: "auto",
                            }, disabled: disabled, enableSearch: true, searchPlaceholder: "Search country...", inputProps: {
                                required: rules?.required?.value,
                                "aria-label": label,
                            }, specialLabel: label, preferredCountries: ["nl", "be", "de", "fr"] })] }), _jsx(ErrorWithIcon, { error: error })] })) }));
};
